export const estadosSds = [
  {
    id: 1,
    estado: 'Borrador',
    textColour: 'light',
    color: 'secondary',
    time: false
  },
  {
    id: 2,
    estado: 'Enviada',
    color: 'info',
    textColour: 'light',
    time: true
  },
  {
    id: 3,
    estado: 'Asignada',
    textColour: 'light',
    color: 'success',
    time: false
  },
  {
    id: 4,
    estado: 'En Ejecución',
    color: 'primary',
    textColour: 'light',
    time: false
  },
  {
    id: 5,
    estado: 'Finalizada',
    textColour: 'light',
    color: 'dark',
    time: false
  },
  {
    id: 6,
    estado: 'Cancelada',
    textColour: 'light',
    color: 'danger',
    time: false
  }
];
export const optionStatus = [
  {
    id: 1,
    nombre: 'Aceptada'
  },
  {
    id: 2,
    nombre: 'Asignada'
  },
  {
    id: 3,
    nombre: 'Rechazada'
  },
  {
    id: 4,
    nombre: 'Borrador'
  },
  {
    id: 5,
    nombre: 'En ejecutación'
  },
  {
    id: 6,
    nombre: 'Finalizada'
  }
];
export const selectOptions = [
  {
    id: 1,
    nombre: 'tipoUbicacion1'
  },
  {
    id: 2,
    nombre: 'tipoUbicacion2'
  },
  {
    id: 3,
    nombre: 'tipoUbicacion3'
  }
];
export const optionUnidadNegocio = [
  {
    id: 1,
    nombre: 'unidadNegocio1'
  },
  {
    id: 2,
    nombre: 'unidadNegocio2'
  },
  {
    id: 3,
    nombre: 'unidadNegocio3'
  },
  {
    id: 4,
    nombre: 'unidadNegocio4'
  }
];
export const statusEnum = {
  borrador: 1,
  enviada: 2,
  asignada: 3,
  enEjecucion: 4,
  finalizada: 5,
  cancelada: 6
};
export const ubicationTypeEnum = {
  locacion: 1,
  /** Pozo - P&WO, Pulling, Abandono */
  pozo: 2,
  /** Operación y Mantenimiento */
  pozoOyM: 3,
  /** Planta de Agua y Petróleo */
  plantaAyP: 4,
  plantaGas: 5,
  ducto: 6,
  edificio: 7,
  uspYBateria: 8,
  almacen: 9,
  energia: 10,
  talleresYBasesDeProveedores: 11,
  locacionOYM: 12,
  genericaOverhead: 13,
  genericaProyecto: 14
};
export const imputationTypeEnum = {
  CECO: 1,
  PEP: 2,
  ORDEN: 3
};
export const assignmentTypeEnum = {
  Normal: 1,
  Directa: 2,
  Mensualizada: 3,
  Automatica: 4
};

export const CALL_ORIGIN_ENUM = {
  assign: 'assign',
  reassign: 'reassign',
  create: 'create'
};

export const workReportLineStatus = {
  pendiente: 1,
  enviar: 2,
  aprobar: 3,
  devolver: 4,
  fijar: 5
};

export const weeklyWorkReportColors = Object.freeze({
  approver: {
    approved: '#FFFFFF,#219E66',
    fixed: '#FFFFFF,#159AD8',
    pending: '#219E66,#FFFFFF',
    returned: '#FFFFFF,#FF6666'
  },
  imputation: {
    daily: '#159AD8',
    weekly: '#FF7600'
  },
  inspector: {
    errorSE: '#FF6666',
    inspected: '#00BF6E',
    inspectorMustAct: '#BFBFBF',
    packetized: '#3865B8',
    rejected: '#FFA4A4',
    revision: '#FF7700',
    sentToSE: '#616161'
  }
});

export const colorReferenceApprover = {
  devuelta: 4,
  aprobada: 3,
  fijada: 5,
  pendiente: 2,
  sinAprobacion: 1,
  cancelada: 0 // BE dice que no existe cancelacion en aprobador
};

export const colorReferenceInspector = {
  enviadaSE: 2,
  errorSE: 4,
  actuarInspector: 7,
  inspeccionada: 5,
  paquetizada: 6,
  cancelada: 3,
  revision: 0
};

export const eventPendingAssignmentId = 0;
export const eventPendingAssignmentName = 'Evento pendiente de asignación';

export const eventAsignmentEnum = {
  all: 1,
  pending: 2,
  assigned: 3
};

export const chipsWordsForEventAsignment = {
  1: 'Todos los eventos',
  2: 'Evento pendiente',
  3: 'Evento asignado'
};

export const colorForProgramPoints = {
  withPP: '#44ADDE',
  withoutPP: '#222222',
  disabledPP: '#c8c8c8'
};

export const colorforCSA = {
  withCSA: '#44ADDE',
  withoutCSA: '#222222'
};
